import { apiSlice } from "../api/apiSlice";

export const assignmentMarkApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAssignmentMarks: builder.query({
      query: () => "/assignmentMark",
    }),
    updateAssignmentMark: builder.mutation({
      query: (body) => ({
        url: `/assignmentMark/${body.id}`,
        method: "PATCH",
        body,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        const response = await queryFulfilled;
        if (response.data) {
          dispatch(
            apiSlice.util.updateQueryData(
              "getAssignmentMarks",
              undefined,
              (draft) => {
                const index = draft.findIndex(
                  (item) => item.id == response.data.id
                );
                if (index !== -1) {
                  draft[index] = response.data;
                }
              }
            )
          );
        }
      },
    }),
  }),
});

export const { useGetAssignmentMarksQuery, useUpdateAssignmentMarkMutation } = assignmentMarkApi;
